import { __assign, __rest } from "tslib";
import React from 'react';
import { useFlag } from '../hooks/useFlag';
export var Flag = function (_a) {
    var condition = _a.condition, render = _a.render, fallbackRender = _a.fallbackRender, Component = _a.component, FallbackComponent = _a.fallbackComponent, children = _a.children, props = __rest(_a, ["condition", "render", "fallbackRender", "component", "fallbackComponent", "children"]);
    var isEnabled = useFlag(condition);
    if (isEnabled) {
        if (render) {
            return React.createElement(React.Fragment, null, render());
        }
        if (Component) {
            return React.createElement(Component, __assign({}, props), children);
        }
        return React.createElement(React.Fragment, null, children);
    }
    if (fallbackRender) {
        return React.createElement(React.Fragment, null, fallbackRender());
    }
    if (FallbackComponent) {
        return React.createElement(FallbackComponent, __assign({}, props), children);
    }
    return null;
};
Flag.displayName = 'Flag';
export default Flag;
//# sourceMappingURL=Flag.js.map